// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2X2Xj","col":"Table_col__jlyqJ","fulfillmentStatus":"Table_fulfillmentStatus__38YmB","emailCol":"Table_emailCol__PUOeR"};